// Globals
import { ReactNode, useMemo } from 'react';

// Helpers
import { SettingsContext } from '../../helpers';

// Hooks
import { useChannelSettings } from '../../hooks';

// Constants
import { DEFAULT_MAIN_COLOR } from '@/constants/common';

type TSettingsContainerProps = {
  children?: ReactNode;
};

const SettingsContainer = ({ children }: TSettingsContainerProps) => {
  const { settings, isLoading } = useChannelSettings();

  const value = useMemo(() => ({
    settings,
    mainColor: settings?.main_color || DEFAULT_MAIN_COLOR,
  }), [settings]);

  if (isLoading) return null;

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContainer;
